import { render, staticRenderFns } from "./demand-detail.vue?vue&type=template&id=7de0d6af&scoped=true"
import script from "./demand-detail.vue?vue&type=script&lang=js"
export * from "./demand-detail.vue?vue&type=script&lang=js"
import style0 from "./demand-detail.vue?vue&type=style&index=0&id=7de0d6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de0d6af",
  null
  
)

export default component.exports